import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import { t } from 'i18next';

import { ShakyErrorIndicator } from '~components/ErrorIndicators/ShakyErrorIndicator';
import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';

interface SelectionCountersProps {
  currentSelectionsCount: number;
  maxSelectionsCount: number;
  sx?: SxProps;
}

export default function SelectionCounters({
  currentSelectionsCount,
  maxSelectionsCount,
  sx,
}: SelectionCountersProps) {
  const theme = useTheme();
  const maxSelectionsCountExceeded = currentSelectionsCount > maxSelectionsCount;
  const color = maxSelectionsCountExceeded ? theme.palette.error.main : undefined;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 2,
        height: '20px',
        justifyContent: 'space-between',
        ...sx,
      }}
    >
      <OverflowAwareText variant="body2" sx={{ flex: 1 }}>
        <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 600, color }}>
          {`${currentSelectionsCount} ${t('common.of')} ${maxSelectionsCount} `}
        </Typography>

        <Typography component="span" sx={{ fontSize: 'inherit' }}>
          {t('dispatch.order.trucks_selected')}
        </Typography>
      </OverflowAwareText>

      {maxSelectionsCountExceeded && (
        <ShakyErrorIndicator message={t('dispatch.order.max_selections_exceeded')} />
      )}
    </Box>
  );
}
